import moment from "moment";
import { DelegatedParkingProductModel, DelegatedParkingRight, DelegeeAssignedProductResponse, DelegeeWithProductsModel, InviteDelegeeResponse, UpdateDelegeeResponse } from "../../models/delegations/DelegatedParkingProductsModel";
import { ParkingRightsRequestModel } from "../../models/ParkingRightsRequestModel";
import { ParkingProductsActionType } from "../actions/parkingProducts.actions";
import { ParkingProductState } from "../reducers/parking-products";

export const applyOptimisticUpdateParkingRightMyProducts = (state: ParkingProductState, updateDelegeeModel: UpdateDelegeeResponse, parkingRightsRequestPayload: ParkingRightsRequestModel, originalDelegee: DelegeeWithProductsModel) => {
    const addedProducts = updateDelegeeModel.assignedProducts
        .filter((product) => !originalDelegee.products.some(
            p => p.pmcId === product.pmcId &&
                 p.contractType === product.contractType &&
                  p.productType == product.productType))
    const deletedProducts = originalDelegee.products
        .filter((p) => !parkingRightsRequestPayload.products.some(
            product => product.pmcId === p.pmcId &&
            product.contractType == p.contractType &&
            product.productType == p.productType));

    updateDelegeeNameInMyProducts(state, originalDelegee, parkingRightsRequestPayload);
    addRowMyProductsDataTable(state, addedProducts, originalDelegee.registrationId, parkingRightsRequestPayload);
    removeRowMyProductsDataTable(state, deletedProducts, originalDelegee.registrationId);
    updateLocatedProductCounters(state, addedProducts, 1);
    updateLocatedProductCounters(state, deletedProducts, -1);
}

export const updateDelegeeNameInMyProducts = (state: ParkingProductState, originalDelegee: DelegeeWithProductsModel, parkingRightsRequestPayload: ParkingRightsRequestModel) => {
    if(originalDelegee.name !== parkingRightsRequestPayload.name) {
        for(const page in state.delegatedParkingProducts.pages) {
            const currentPage = state.delegatedParkingProducts.pages![page as any as number];
            currentPage.data!.forEach(product => {
                if(product.delegee.registrationId === originalDelegee.registrationId) {
                    product.delegee.name = parkingRightsRequestPayload.name ?? "";
                }
            });
        }
    }
}

export const applyOptimisticUpdateParkingRightMyFleet = (state: ParkingProductState, updateDelegeeModel: UpdateDelegeeResponse, parkingRightsRequestPayload: ParkingRightsRequestModel, originalDelegee: DelegeeWithProductsModel) => {
    const addedProducts = updateDelegeeModel.assignedProducts
        .filter((product) => !originalDelegee.products.some(
            p => p.pmcId === product.pmcId &&
                 p.contractType === product.contractType &&
                  p.productType == product.productType))
    const deletedProducts = originalDelegee.products
        .filter((p) => !parkingRightsRequestPayload.products.some(
            product => product.pmcId === p.pmcId &&
            product.contractType == p.contractType &&
            product.productType == p.productType));

    updateDelegeeNameInMyFleet(state, originalDelegee.registrationId, originalDelegee.name, parkingRightsRequestPayload.name ?? "");
    applyOptimisticAddMyFleet(state, addedProducts, originalDelegee.registrationId);
    applyOptimisticRevokeMyFleet(state, deletedProducts.map(p => p.parkingRightId));
}

export const updateDelegeeNameInMyFleet = (state: ParkingProductState, delegeeId: string ,delegeeName: string, newDelegeeName: string) =>{
  if(delegeeName !== newDelegeeName) {
    for(const page in state.delegees.pages) {
      const currentPage = state.delegees.pages[page as any as number];
      currentPage.data?.forEach(delegee => {
          if(delegee.registrationId === delegeeId) {
              delegee.name = newDelegeeName;
              return;
          }
      });
    }
  }
}

export const applyOptimisticAddMyFleet = (state: ParkingProductState, assignedProducts: DelegeeAssignedProductResponse[], delegeeId: string) => {
  if(assignedProducts.length == 0){
    return;
  }

  for (const page in state.delegees.pages) {
      const currentPage = state.delegees.pages[page as any as number];
      for (const delegee of currentPage.data ?? []) {
        if(delegee.registrationId == delegeeId){
          assignedProducts.forEach(p => {
            delegee.products.push({
              contractType: p.contractType,
              productType: p.productType,
              created: moment().toDate(),
              pmcId: p.pmcId,
              parkingRightId: p.entryRightId,
              location: state.parkingProducts.data?.find(x => x.pmcId == p.pmcId)?.location,
              name: state.parkingProducts.data?.find(x => x.pmcId == p.pmcId)?.pmcName,
            } as DelegatedParkingProductModel);
          });
          return;
        }
      }
  }
}

export const  applyOptimisticRevokeMyFleet = (state: ParkingProductState, parkinRightIds: string[]) => {
  if(parkinRightIds.length == 0){
    return;
  }

  for (const page in state.delegees.pages) {
      const currentPage = state.delegees.pages[page as any as number];
      for (const delegee of currentPage.data!) {
        delegee.products = delegee.products.filter((p) => !parkinRightIds.includes(p.parkingRightId));
      }
  }
}

export const applyOptimisticRevokeMyProducts = (state: ParkingProductState, parkingRightIds: string[]) => {
  if (parkingRightIds.length === 0) {
    return;
  }

  const removedProducts: DelegatedParkingProductModel[] = [];
  let rowsRemoved = 0;
  for (const page in state.delegatedParkingProducts.pages) {
    const currentPage = state.delegatedParkingProducts.pages![page as any as number];
    const before = currentPage.data!.length;
    removedProducts.push(...currentPage.data!.filter(x => parkingRightIds.includes(x.parkingRight.parkingRightId)).map(x => x.parkingRight));
    currentPage.data = currentPage.data!.filter(x => !parkingRightIds.includes(x.parkingRight.parkingRightId));
    rowsRemoved += before - currentPage.data.length;
  }
  state.delegatedParkingProducts.totalRecords -= rowsRemoved;
  updateLocatedProductCounters(state, removedProducts, -1);
}

export const applyOptimisticDeleteMyFleet = (state: ParkingProductState, deleteModel: ParkingProductsActionType) => {
  for (const page in state.delegees.pages) {
      const currentPage = state.delegees.pages[page as any as number];
      currentPage.data = currentPage.data?.filter((d) => !deleteModel.deletedDelegeeIds?.includes(d.registrationId));
  }
  state.delegees.totalRecords --;
}

export const applyOptimisticDeleteMyProducts = (state: ParkingProductState, deleteModel: ParkingProductsActionType) => {
  const delegeeIds = deleteModel.deletedDelegeeIds ?? [];
  if (delegeeIds.length === 0) {
    return;
  }

  const removedProducts: DelegatedParkingProductModel[] = [];
  let rowsRemoved = 0;
  for (const page in state.delegatedParkingProducts.pages) {
    const currentPage = state.delegatedParkingProducts.pages![page as any as number];
    const before = currentPage.data!.length;
    removedProducts.push(...currentPage.data!.filter(x => delegeeIds.includes(x.delegee.registrationId)).map(x => x.parkingRight));
    currentPage.data = currentPage.data!.filter(x => !delegeeIds.includes(x.delegee.registrationId));
    rowsRemoved += before - currentPage.data.length;
  }
  state.delegatedParkingProducts.totalRecords -= rowsRemoved;
  updateLocatedProductCounters(state, removedProducts, -1);
}

export const applyOptimisticInviteParkingRightMyProducts = (state: ParkingProductState, inviteDelegeeModel: InviteDelegeeResponse, parkingRightsRequestPayload: ParkingRightsRequestModel) => {
    addRowMyProductsDataTable(state, inviteDelegeeModel.assignedProducts, inviteDelegeeModel.delegeeId, parkingRightsRequestPayload);
    updateLocatedProductCounters(state, inviteDelegeeModel.assignedProducts, 1);
}

export const removeRowMyProductsDataTable = (state: ParkingProductState, removedProducts: DelegatedParkingProductModel[], delegeeRegistrationId: string) => {
    const removedParkingRightIds = removedProducts.map(p => p.parkingRightId);
    if (removedParkingRightIds.length === 0) { return; }
    let rowsRemoved = 0;
    for(const page in state.delegatedParkingProducts.pages) {
      const currentPage = state.delegatedParkingProducts.pages![page as any as number];
      const before = currentPage.data!.length;
      currentPage.data = currentPage.data!.filter(x =>
        !(removedParkingRightIds.includes(x.parkingRight.parkingRightId) &&
          x.delegee.registrationId === delegeeRegistrationId)
      );
      rowsRemoved += before - currentPage.data.length;
    }
    state.delegatedParkingProducts.totalRecords -= rowsRemoved;
  }

export const addRowMyProductsDataTable = (state: ParkingProductState, assignedProducts: DelegeeAssignedProductResponse[], delegeeId: string, parkingRightsRequestPayload: ParkingRightsRequestModel) =>{
    for(const page in state.delegatedParkingProducts.pages) {
      const currentPage = state.delegatedParkingProducts.pages![page as any as number];
      assignedProducts.filter(delegee => {
        if(!state.selectedParkingRightProductPlaceId){
          return true;
        }
        return delegee.placeId === Number(state.selectedParkingRightProductPlaceId);
      })
      .forEach(assignedProduct => {
        const product = state.parkingProducts.data?.find(x => x.pmcId == assignedProduct.pmcId);
        let newDelegatedParkingRight : DelegatedParkingRight = {
          parkingRight: {
             contractType: assignedProduct.contractType,
             productType: assignedProduct.productType,
             pmcId: assignedProduct.pmcId,
             created: moment().toDate(),
             name: product?.pmcName ?? "",
             parkingRightId: assignedProduct.entryRightId,
             location: product?.location ?? "",
             status: 0,
             id: Math.ceil(Math.random() * 1000000)
          },
          delegee: {
            emailAddress: parkingRightsRequestPayload.email,
            name: parkingRightsRequestPayload.name ?? "",
            registrationId: delegeeId,
            invitationAccepted: false,
          }
        }
        currentPage.data!.unshift(newDelegatedParkingRight);
      });
    }
  }

export const updateLocatedProductCounters = (
    state: ParkingProductState, 
    products: (DelegeeAssignedProductResponse | DelegatedParkingProductModel)[], 
    increment: number = 1 // Pass -1 for decrease, 1 for increase
) => {
    products.forEach(product => {
        const parkingproduct = state.locatedParkingProducts.data?.find(p => 
            p.parkingProducts.some(pp => pp.pmcId === product.pmcId)
        );
        
        if (parkingproduct) {
            parkingproduct.totalDelegatedParkingRights += increment;
            
            const pmc = parkingproduct.parkingProducts.find(pp => pp.pmcId === product.pmcId);
            if (pmc) {
                pmc.totalDelegatedParkingRights = Math.max(0, (pmc.totalDelegatedParkingRights || 0) + increment);
            }
        }
    });
}